import axios from "axios";
import store from "../store";
import { baseUrl } from "../config";

export default () => {
  const instance = axios.create({
    baseURL: baseUrl,
    // baseURL: `http://192.168.68.62:3031/`,
    headers: {
      Authorization: `Bearer ${store.state.AuthModule.token}`,
      "X-App-Version": store.getters.getAppVersion,
    },
  });
  // 410 = this build is outdated (server/src/policies/checkAppVersion.js)
  instance.interceptors.response.use(undefined, (error) => {
    if (error?.response?.status === 410) {
      store.commit("setIsOpenNewVersionModal", true);
    }
    return Promise.reject(error);
  });
  return instance;
};
